import { render, staticRenderFns } from "./comofunciona.vue?vue&type=template&id=6bf8ac62&"
import script from "./comofunciona.vue?vue&type=script&lang=js&"
export * from "./comofunciona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports